module.exports = __webpack_public_path__ + "static/img/040奥丁投票.dd2599b.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/smPicImgs/040奥丁投票.jpg
// module id = Yfgp
// module chunks = 0